<span>{{ orderId }}</span>
<lum-ui-icon
  *ngIf="hasFlaggedTag"
  class="mx-3 align-self-center"
  [icon]="icon"
  [color]="color"
  [matTooltip]="tooltip"
  [matTooltipPosition]="position"
  [matTooltipClass]="tooltipClass"
  [matTooltipOffset]="offset"
></lum-ui-icon>
